export enum TodoItemTypeEnum {
  checklist = 'checklist',
  note = 'note',
}
